import React, { useState, useMemo } from "react"
import PropTypes from "prop-types"
import { Card, Row, Button, ModalBody, ModalFooter, Form, Col, Input } from "reactstrap"
import i18n from "../../../i18n"

import "flatpickr/dist/themes/material_blue.css";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom"
import TableContainer from "../../../components/Common/TableContainer";
import * as Yup from 'yup';
import { useFormik } from "formik";

const Step1 = (props) => {

  const { setStep, setGroupDestinationRoutingModal, listModifyRouting, setSelectRouting  } = props;

  const dispatch = useDispatch();

  const autoformik = useFormik({
    initialValues: {
      search: "",
      serviceNumber: "",
      status: "",
      type: ""
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      serviceNumber: Yup.string(),
      status: Yup.string(),
      type: Yup.string()
    })
  });

  const onClickModifyRouting = (args) => {
    setStep(2);
    setSelectRouting(args);
  }

  const onClicklCancel = () => {
    setGroupDestinationRoutingModal(false)
  }

  const handleOrderClicks = () => {
    setOrder("");
    setIsEdit(false);
    toggle();
  };

  const handleOrderClick = (arg) => {
    const order = arg;
    setOrder({
      id: order.id,
      orderId: order.orderId,
      billingName: order.billingName,
      orderDate: order.orderDate,
      total: order.total,
      paymentStatus: order.paymentStatus,
      paymentMethod: order.paymentMethod,
      badgeClass: order.badgeClass,
    });

    setIsEdit(true);

    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: i18n.t("Company"),
        accessorKey: 'company',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: i18n.t("ServiceNumber"),
        accessorKey: 'serviceNumber',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: i18n.t("StartingPoint"),
        accessorKey: 'startingPoint',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Destination"),
        accessorKey: 'destination',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Passengers"),
        accessorKey: 'passengers',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Scales"),
        accessorKey: 'numberScales',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Date"),
        accessorKey: 'date',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Hour"),
        accessorKey: 'hour',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: i18n.t("Type"),
        accessorKey: 'type',
        enableColumnFilter: false,
        enableSorting: true
      },
      {
        header: '',
        accessorKey: 'action',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => {
          return (
            <Link
              className="btn btn-sm btn-danger fs-11"
              onClick={() => onClickModifyRouting(cellProps.row.original)}>
                {i18n.t("Modify")}
            </Link>
          );
        }
      }
    ],
    [handleOrderClick, setGroupDestinationRoutingModal]
  );

  return (
    <Card>
      <ModalBody>
        <Col> 
          <Form className="row gy-2 gx-3 align-items-center" onSubmit={autoformik.handleSubmit}>
            <Col xxl={3} md={3} xs={12}>
              <div className="col-sm-auto">                        
                <Input type="text" name="search" className="form-control" id="searchInput" placeholder={i18n.t("SearchCompany")}
                  value={autoformik.values.search}
                  onChange={autoformik.handleChange}
                  onBlur={autoformik.handleBlur}
                  invalid={
                    autoformik.touched.search && autoformik.errors.search ? true : false
                  } />
                {
                  autoformik.errors.search && autoformik.touched.search ? (
                    <FormFeedback type="invalid">{autoformik.errors.search}</FormFeedback>
                  ) : null
                }
              </div>
            </Col>
            <Col xxl={3} md={3} xs={12}>
              <div className="col-sm-auto">
                <Input type="text" name="serviceNumber" className="form-control" id="serviceNumberInput" placeholder={i18n.t("ServiceNumber")}
                  value={autoformik.values.serviceNumber}
                  onChange={autoformik.handleChange}
                  onBlur={autoformik.handleBlur}
                  invalid={
                    autoformik.touched.serviceNumber && autoformik.errors.serviceNumber ? true : false
                  } />
                {
                  autoformik.errors.serviceNumber && autoformik.touched.serviceNumber ? (
                    <FormFeedback type="invalid">{autoformik.errors.serviceNumber}</FormFeedback>
                  ) : null
                }
              </div>
            </Col>
            <Col xxl={3} md={3} xs={12}>
              <div className="col-sm-auto">
                <Input type="text" name="status" className="form-control" id="statusInput" placeholder={i18n.t("Status")}
                  value={autoformik.values.status}
                  onChange={autoformik.handleChange}
                  onBlur={autoformik.handleBlur}
                  invalid={
                    autoformik.touched.status && autoformik.errors.status ? true : false
                  } />
                {
                  autoformik.errors.status && autoformik.touched.status ? (
                    <FormFeedback type="invalid">{autoformik.errors.status}</FormFeedback>
                  ) : null
                }
              </div>
            </Col>
            <Col xxl={3} md={3} xs={12}>
              <div className="col-sm-auto">
                <Input type="text" name="type" className="form-control" id="typeInput" placeholder={i18n.t("Type")}
                  value={autoformik.values.type}
                  onChange={autoformik.handleChange}
                  onBlur={autoformik.handleBlur}
                  invalid={
                    autoformik.touched.type && autoformik.errors.type ? true : false
                  } />
                {
                  autoformik.errors.type && autoformik.touched.type ? (
                    <FormFeedback type="invalid">{autoformik.errors.type}</FormFeedback>
                  ) : null
                }
              </div>
            </Col>
          </Form>
          <TableContainer
            columns={columns}
            data={listModifyRouting || []}
            isGlobalFilter={false}
            isAddButton={false}
            isCustomPageSize={false}
            handleUserClick={handleOrderClicks}
            isPagination={true}
            SearchPlaceholder="26 records..."
            buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2 addOrder-modal"
            buttonName=""
            tableClass="table table-bordered mb-0 fs-11"
            theadClass=""
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
          />
        </Col>
      </ModalBody>
      <ModalFooter>
        <Button
          className="btn-light"
          type="button"
          color="secondary"
          data-dismiss="modal"
          onClick={onClicklCancel}
        >
          {i18n.t("Cancel")}
        </Button>
      </ModalFooter>
    </Card>
  )
}

Step1.propTypes = {
  setStep: PropTypes.func,
  setGroupDestinationRoutingModal: PropTypes.func,
  listModifyRouting: PropTypes.array,
  setSelectRouting: PropTypes.func
}

export default Step1;
